<template>
  <div id="nav-bar">
    <div id="left">
      <ul>
        <li><router-link :to="{name: 'home'}">home</router-link></li>
        <li><router-link :to="{name: 'rules'}">rules</router-link></li>
        <li><router-link :to="{name: 'hints'}">hints</router-link></li>
        <li><a target="_blank" rel="noopener noreferrer" href="https://www.cs.ubc.ca/~udls/puzzle/2017">2017 hunt</a></li>
      </ul>
    </div>
    <div id="right">
    <ul>
      <li v-for="puzzle in puzzles" :key="puzzle.name">
        <router-link :to="{name: 'puzzle', params: {id: puzzle.id}}">{{ puzzle.name }}</router-link>
        <span>&nbsp;</span>
        <router-link :to="{name: 'solution', params: {id: puzzle.id}}">(soln)</router-link>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
// console.log(puzzles)

export default {
  name: 'NavBar',
  computed: {
    puzzles () {
      return this.$store.state.puzzles
    },
  }
}
</script>
